import { Box, Heading } from '@chakra-ui/react'
import React from 'react'
import GitHubStats from './GitHubStats'
import OtherStat from './OtherStat'

const Statistics = () => {
  return (
    <Box id="statistics" pos={"relative"} zIndex={2} p="60px 0px">
       <Box display={"inline-block"}>
        <Heading color="black">Statistics</Heading>
        <Box
          h="6px"
          w="100%"
          mt="10px"
          bg="rgb(34,83,200)"
          borderRadius={"5px"}
        ></Box>
      </Box>
        <GitHubStats/>
        <OtherStat/>
    </Box>
  )
}

export default Statistics